











































import { Vue, Component } from 'vue-property-decorator'
import copy from '../utils/copy'
import FileSave from 'file-saver'

@Component
export default class  extends Vue {

  selectedCategories: Array<any> = [];
  isGenerating: boolean = false;
  result: string = '';
  separator: string = '';
  numberOfAgents: string = '';
  snackbar: boolean = false;

  get categories () {
    const categories = this.$store.state.categories;
    return Object.keys(categories).map((v) => {
      return categories[v];
    }).reduce((pre: any, cur: any) => pre.concat(cur))
  }

  generate () {
    this.isGenerating = true;
    const data = Object.keys(this.selectedCategories).map((v: any) => {
      return this.$store.state.data[this.selectedCategories[v]];
    }).reduce((pre, cur) => pre.concat(cur));
    const numberOfAgents = parseInt(this.numberOfAgents);
    const separator = (this.separator == `\\n`) ? '\r\n' : this.separator;
    if (numberOfAgents > data.length) {
      this.result = data.join(separator);
    } else {
      this.result = this.generateRandomAgents(data, separator);
    }
    this.isGenerating = false;
  }

  generateRandomAgents (data: Array<any>, separator: string): string {
    for (let i = data.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [data[i], data[j]] = [data[j], data[i]];
    }
    let result = []
    const numberOfAgents = parseInt(this.numberOfAgents);
    for (let i = 0; i < numberOfAgents; i++) {
      const index = Math.floor(Math.random() * data.length);
      result.push(data[index]);
    }
    return result.join(separator);
  }

  copy () {
    copy(this.result);
    this.snackbar = true;
  }

  download () {
    const blob = new Blob([this.result], { type: 'text/plain?charset=utf-8'});
    FileSave.saveAs(blob, `useragents.txt`);
  }

}




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/random.vue